import React, { ReactNode } from 'react'
import type { GuideStatus } from '../../utils'
import styles from './health.module.sass'

export const NoFigures = ({ text = 'No figures for this period yet.' }: { text?: string }) => <p className={styles.noFigures}>{text}</p>

type FigureProps = {
  value: string
  label: string
  children?: ReactNode
}

// The big number, what it counts and its pills.
export const Figure = ({ value, label, children }: FigureProps) => (
  <div className={styles.figure}>
    <span className={styles.big}>{value}</span>
    <div className={styles.figureText}>
      <span className={styles.figureLabel}>{label}</span>
      <div className={styles.pills}>{children}</div>
    </div>
  </div>
)

const STATUS_CLASS: Record<GuideStatus, string> = {
  on_track: styles.onTrack,
  watch: styles.watch,
  needs_attention: styles.attention,
}

export const StatusPill = ({ status, label }: { status: GuideStatus; label: string }) => (
  <span className={`${styles.status} ${STATUS_CLASS[status]}`}>{label}</span>
)

export const ChangePill = ({ text }: { text: string | null }) => {
  if (!text) return null

  return <span className={styles.change}>{text}</span>
}
